import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { useDateTimeFormatter } from "@opensea/i18n";
import { Chip, Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
export const ProfileJoinedAtChipFragment = graphql(`
  fragment ProfileJoinedAtChip on Profile {
    dateJoined
  }
`);
export function ProfileJoinedAtChip(t0) {
  const $ = _c(5);
  const {
    profile: profileKey,
    variant,
    chipVariant
  } = t0;
  const profile = readFragment(ProfileJoinedAtChipFragment, profileKey);
  const t = useTranslations("ProfileJoinedAtChip");
  const dateFormat = useDateTimeFormatter();
  if (!profile.dateJoined) {
    return;
  }
  const dateJoined = dateFormat(new Date(profile.dateJoined), {
    display: "date",
    day: undefined
  });
  let t1;
  if ($[0] !== chipVariant || $[1] !== dateJoined || $[2] !== t || $[3] !== variant) {
    t1 = variant === "compact" ? <Tooltip content={<>{t("joined")} {dateJoined}</>}><Chip variant={chipVariant}>{dateJoined}</Chip></Tooltip> : <Chip variant={chipVariant}>{t("joined")} {dateJoined}</Chip>;
    $[0] = chipVariant;
    $[1] = dateJoined;
    $[2] = t;
    $[3] = variant;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}